export default function About() {
  return (
    <section id="about" className="section">
      <h2>About Us</h2>

      <p className="subtitle">
        Kurush — A story of tradition, patience, and handcrafted beauty.
      </p>

      <p>
        Handcrafted embroidery designs that celebrate tradition, patience, and
        artistry.
      </p>

      <p>
        Kurush is dedicated to preserving the quiet beauty of handcrafted
        embroidery. Each design is created with care using traditional kadhai
        techniques — where time, patience, and skilled hands come together in
        every stitch.
      </p>

      <p>
        Our pieces are not rushed. They are made slowly, thoughtfully, and with
        deep respect for the craft.
      </p>

      <h3>Founders’ Note</h3>

      <p>
        In many Indian homes, embroidery was never a profession. It was something
        women did between cooking, caring, and everyday life.
      </p>

      <p>
        Stitches were made in spare moments — on charpais, near windows, during
        afternoon pauses.
      </p>

      <p>
        Over time, those stitches were left behind, replaced by responsibility
        and routine.
      </p>

      <p>
        Kurush exists to bring those crafts back — to honor the quiet artistry of
        hands that once stitched stories into fabric.
      </p>
    </section>
  );
}
